import React from "react";
import styled, { keyframes } from "styled-components";
import LazyLoad from "react-lazyload";

const loadingAnimation = keyframes`
  0% {
    background-color: #fff;
  }
  50% {
    background-color: #ccc;
  }
  100% {
    background-color: #fff;
  }
`;

const Placeholder = styled.div`
  animation: ${loadingAnimation} 1s infinite;
`;

const StyledImage = styled.img``;

const LazyImage = ({
  src,
  alt,
  className,
}: {
  src: string;
  alt: string;
  className?: string;
}) => {
  const refPlaceholder = React.useRef(null);

  const removePlaceholder = () => {
    refPlaceholder.current.remove();
  };

  return (
    <div>
      <Placeholder ref={refPlaceholder} />
      <LazyLoad>
        <img
          onLoad={removePlaceholder}
          onError={removePlaceholder}
          src={src}
          alt={alt}
          className={className}
        />
      </LazyLoad>
    </div>
  );
};

export default LazyImage;
